import React from 'react';

import {
  Box,
  Text,
  Input,
  FormControl,
  FormLabel,
  VStack,
  InputGroup,
  InputLeftAddon,
  HStack,
} from '@chakra-ui/react';

import { useColors } from './colors';

const SupplierInventory = ({ listing }) => {
  const {
    bgColor,
    borderColor,
    headingColor,
    subTextColor: labelColor,
    hoverBg: readOnlyBg,
    inputColor: readOnlyColor,
  } = useColors();

  const supplierName =
    listing?.supplier?.altName || listing?.supplier?.name || 'Supplier Not Selected';

  return (
    <Box
      bg={bgColor}
      borderRadius="xl"
      p={6}
      border="1px solid"
      borderColor={borderColor}
      w="100%"
    >
      <Text fontSize="xl" fontWeight="semibold" color={headingColor} mb={6}>
        Supplier Inventory ({supplierName})
      </Text>

      <VStack spacing={5} align="stretch">
        {/* Price and Quantity Row */}
        <HStack spacing={5} align="stretch">
          <FormControl>
            <FormLabel fontSize="sm" fontWeight="semibold" color={labelColor} mb={2}>
              Cost
            </FormLabel>
            <InputGroup>
              <InputLeftAddon children="$" />
              <Input
                value={listing?.supplier?.cost || ''}
                isReadOnly
                bg={readOnlyBg}
                color={readOnlyColor}
                cursor="not-allowed"
                size="md"
                borderRadius="md"
                placeholder="--"
              />
            </InputGroup>
          </FormControl>

          <FormControl>
            <FormLabel fontSize="sm" fontWeight="semibold" color={labelColor} mb={2}>
              Quantity
            </FormLabel>
            <InputGroup>
              <InputLeftAddon children="#" />
              <Input
                value={listing?.supplier?.stock || ''}
                isReadOnly
                bg={readOnlyBg}
                color={readOnlyColor}
                cursor="not-allowed"
                size="md"
                borderRadius="md"
                placeholder="--"
              />
            </InputGroup>
          </FormControl>
        </HStack>

        {/* Brand Field */}
        <FormControl>
          <FormLabel fontSize="sm" fontWeight="semibold" color={labelColor} mb={2}>
            Brand
          </FormLabel>
          <Input
            value={listing?.supplier?.brand || ''}
            isReadOnly
            bg={readOnlyBg}
            color={readOnlyColor}
            cursor="not-allowed"
            size="md"
            borderRadius="md"
            placeholder="--"
          />
        </FormControl>
      </VStack>
    </Box>
  );
};

export default SupplierInventory;
